import React from "react";
import { useNavigate } from "react-router-dom";
// import img from '../metaverseassets/buildimg.png';
import "./Build.css";

export default function Build() {
   const navigation = useNavigate();

  return (
    <div id="metaverse-build" className="marketmainclass">
      <div className="left">
        <h2 className="heading">
          Build a Complete Metaverse Ecosystem with BastionEx
        </h2>
        <button onClick={() => navigation("/contact_us")}>Get a Free Consultation Today</button>
      </div>
      {/* <div className="right">
            <img src={img} alt="error" />
        </div> */}
    </div>
  );
}
